import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditPancilIcon from "../GFSRulesIcon/EditPancilIcon";
import DeleteIcon from "../GFSRulesIcon/DeleteIcon";
import Modal from "react-bootstrap/Modal";
import { Box } from "@material-ui/core";
import { Typography } from "@mui/material";
import { getCarrierName } from "src/utils/Currency";
import CopyAllIcon from "@mui/icons-material/CopyAll";
import { addFeeRule } from "src/Api/Services/GfsRule";
import { useSnackbar } from "notistack5";
import { status } from "nprogress";

const FeeRuleCard = ({
  feeRulesList,
  setEditFeeRuleId,
  handleShowAddFeeRule,
  reset,
  editFeeRuleId,
  handleDeleteFeeRule,
  carrierDropdown3,
  fetchCarrierDropdown,
  setDuplicateFeeRuleId,
  duplicateFeeRuleId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const parseFeeRuleToForm = (data, nextSequenceNum = null) => {
    // Updated: Match optional "-" only, and assume "+" if undefined
    const feeAmountMatch =
      (data.feeAmount &&
        data.feeAmount.match(/^([A-Z]{3})(-)?(\d+(?:\.\d{1,2})?)/)) ||
      [];

    const feePercentMatch =
      (data.feePercent && data.feePercent.match(/^(-)?(\d+(?:\.\d{1,2})?)$/)) ||
      [];

    const oncePerBookingMatch =
      (data.oncePerBookingFeeAmount &&
        data.oncePerBookingFeeAmount.match(
          /^([A-Z]{3})(\d+(?:\.\d{1,2})?)$/
        )) ||
      [];

    const minPriceMatch =
      (data.minPrice &&
        data.minPrice.match(/^([A-Z]{3})(\d+(?:\.\d{1,2})?)$/)) ||
      [];

    const maxPriceMatch =
      (data.maxPrice &&
        data.maxPrice.match(/^([A-Z]{3})(\d+(?:\.\d{1,2})?)$/)) ||
      [];

    return {
      carrier: data?.carrier || "",
      sequenceNum:
        nextSequenceNum !== null ? nextSequenceNum : data?.sequenceNum || null,
      travelDateEffective: data?.travelDateEffective || "",
      travelDateDiscontinue: data?.travelDateDiscontinue || "",
      ticketingDateEffective: data?.ticketingDateEffective || "",
      ticketingDateDiscontinue: data?.ticketingDateDiscontinue || "",
      origin: data?.origin || "",
      destination: data?.destination || "",

      // Split feeAmount
      discountType: feeAmountMatch.length
      ? feeAmountMatch[2] === "-" ? "-" : "+"
      : "",
      feeAmtCrr: feeAmountMatch[1] || "",
      feeAmtPrice: feeAmountMatch[3] || "",

      // Split oncePerBookingFeeAmount
      oncePerBookingFeeAmtCurr: oncePerBookingMatch[1] || "",
      oncePerBookingFeeAmtPrice: oncePerBookingMatch[2] || "",

      // Split feePercent
      feePercentDiscount: feePercentMatch.length
        ? feePercentMatch[1] === "-"
          ? "-"
          : "+"
        : "",
      feePercentPrice: feePercentMatch[2] || "",

      suppress: data?.suppress || false,

      // Split minPrice
      minPriceCurr: minPriceMatch[1] || "",
      minPriceAmt: minPriceMatch[2] || "",

      // Split maxPrice
      maxPriceCurr: maxPriceMatch[1] || "",
      maxPriceAmt: maxPriceMatch[2] || "",

      tripType: data?.tripType || "",
      cabinClass: data?.cabinClass || "",
      cabinClassMatchMode: data?.cabinClassMatchMode || "",
      passengerType: data?.passengerType || "",
      interline: data?.interline || "",
      sliceInterline: data?.sliceInterline || "",
      minSegments: data?.minSegments ?? null,
      minTotalSegments: data?.minTotalSegments ?? null,
      maxHoursToDeparture: data?.maxHoursToDeparture ?? null,
      priceSource: data?.priceSource || "",
      status: data?.status || false,
    };
  };

  const editFeeRule = (item) => {
    setEditFeeRuleId(item?.sequenceNum);
    const formValues = parseFeeRuleToForm(item);

    reset(formValues);
    handleShowAddFeeRule();
  };

  const [showConfirm, setShowConfirm] = useState(false);

  const handleClose = () => setShowConfirm(false);
  const handleShow = (item) => {
    setEditFeeRuleId(item?.sequenceNum);
    setShowConfirm(true);
  };

  const handleDuplicate = async (item) => {
    const nextSequence = item.sequenceNum + 1;

    setDuplicateFeeRuleId(item?.sequenceNum);
    const formValues = parseFeeRuleToForm(item, nextSequence);

    reset(formValues);
    handleShowAddFeeRule();
    // try {
    //   const res = await addFeeRule(item);
    //   if (res?.data?.httpStatusCodes === 200) {
    //     enqueueSnackbar(res.data.msg, { variant: "success" });

    //     fetchCarrierDropdown();
    //   } else {
    //     enqueueSnackbar(res.data.msg, { variant: "error" });
    //   }
    // } catch (error) {
    //   console.error("Error duplicating fee rule:", error);
    //   enqueueSnackbar("Network error: Could not make copy", {
    //     variant: "error",
    //   });
    // }
  };
  return (
    <div className="FeeRuleDetals">
      
        <TableContainer component={Paper}>
          <div style={{ maxHeight: "620px", overflowY: "auto" }}>
          <div style={{ maxHeight: "620px", overflowX: 'auto' }}>
            <Table sx={{ minWidth: 1200 }} aria-label="sticky table">
               <TableHead>
                  <TableRow>
                    {[
                      "S.N", "Carrier", "Status", "Origin/Destination", "CabinClass",
                      "TravelDate Effective", "TravelDate Discontinue", "Fee Percent", "Fee Amount",
                      "Suppress", "TicketingDate Effective", "TicketingDate Discontinue",
                      "Once/Booking Fee Amount", "Trip Type", "Cabin Class Match Mode",
                      "Passenger Type", "Min Price", "Max Price", "Interline", "Slice Interline",
                      "Min Segments", "Min Total Segments", "Max Hours To Departure", "Price Source", "Action"
                    ].map((label, i) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{
                          position: "sticky",
                          top: 0,
                          zIndex: 10,
                          background: "#ffffffff",
                          zIndex: label === "Action" ? 2 : 100,
                          minWidth: label === "Action" ? 120 : "auto",
                        }}
                      >
                        {label}
                      </TableCell>
                    ))}
                  </TableRow>
              </TableHead>
              <TableBody>
                {feeRulesList?.length > 0 ? (
                  feeRulesList?.map((item, index) => (
                    <TableRow className={item.status ? "bg-[#ebf8f2] text-[#0f172a]" : "bg-white"} key={index}>
                      <TableCell align="center">{item?.sequenceNum}</TableCell>
                      <TableCell align="center">
                        {getCarrierName(carrierDropdown3, item.carrier) ||
                          item.carrier}
                      </TableCell>
                      <TableCell align="center">
                        {item.status ? "Active" : "Inactive"}
                      </TableCell>
                      <TableCell align="center">
                        {item.origin || "-"}/{item.destination || "-"}
                      </TableCell>
                      <TableCell align="center">{item.cabinClass || "-"}</TableCell>
                      <TableCell align="center">
                        {item.travelDateEffective || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.travelDateDiscontinue || "-"}
                      </TableCell>
                      <TableCell align="center">{item.feePercent || "-"}</TableCell>
                      <TableCell align="center">{item.feeAmount || "-"}</TableCell>
                      <TableCell align="center">
                        {item.suppress ? "True" : "False"}
                      </TableCell>
                      <TableCell align="center">
                        {item.ticketingDateEffective || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.ticketingDateDiscontinue || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.oncePerBookingFeeAmount || "-"}
                      </TableCell>
                      <TableCell align="center">{item.tripType || "-"}</TableCell>
                      <TableCell align="center">
                        {item.cabinClassMatchMode || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.passengerType || "-"}
                      </TableCell>
                      <TableCell align="center">{item.minPrice || "-"}</TableCell>
                      <TableCell align="center">{item.maxPrice || "-"}</TableCell>
                      <TableCell align="center">{item.interline || "-"}</TableCell>
                      <TableCell align="center">
                        {item.sliceInterline || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.minSegments || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.minTotalSegments || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.maxHoursToDeparture || "-"}
                      </TableCell>
                      <TableCell align="center">
                        {item.priceSource || "-"}
                      </TableCell>
                      <TableCell 
                        align="center"
                        sx={{
                        position: "sticky",
                        right: 0,
                        background: "#fff",
                        zIndex: 1,
                        minWidth: "120px",
                      }}
                      >
                        <div className="d-flex gap-2">
                          <button
                            onClick={() => editFeeRule(item)}
                            type="button"
                            class="editdeleteBtn editbtn d-flex gap-1 align-items-center"
                          >
                            <EditPancilIcon />
                          </button>
                          <button
                            type="button"
                            class="editdeleteBtn deltbtn d-flex gap-1 align-items-center"
                            onClick={() => handleShow(item)}
                          >
                            {" "}
                            <DeleteIcon />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDuplicate(item)}
                            class="editdeleteBtn copybtn d-flex gap-1 align-items-center"
                          >
                            <CopyAllIcon />
                          </button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <p className="text-center text-danger mt-3">No Data Found</p>
                )}
              </TableBody>
            </Table>
          </div>
        </div>  
        </TableContainer>    

      {/*---------- Fee Rule Delete Modal ---------*/}
      <Modal
        show={showConfirm}
        onHide={handleClose}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="custom-delete-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 4, pb: 4 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{
                fontSize: 16,
                fontWeight: 500,
                textAlign: "center",
                color: "#333",
                mb: 4,
              }}
            >
              Are you sure you want to delete this?
            </Typography>

            <div className="d-flex justify-content-center gap-3">
              <button
                className="btn btn-outline-secondary px-4"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="btn btn-danger px-4"
                onClick={() => {
                  handleDeleteFeeRule(editFeeRuleId);
                  handleClose();
                  setEditFeeRuleId(null);
                }}
              >
                Confirm
              </button>
            </div>
          </Box>
        </Modal.Body>
      </Modal>

      {/* <Modal
        show={showConfirm}
        onHide={handleClose}
        style={{ borderRadius: 10 }}
        dialogClassName="custom-modal custom-delete-modal"
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Box sx={{ px: 2 }}>
            <Typography
              variant="h6"
              component="h6"
              sx={{
                mb: 3,
                fontSize: 16,
                fontWeight: "500",
                textAlign: "center",
              }}
            >
              Are you sure you want to delete this?
            </Typography>

            <div className="d-flex justify-content-center gap-2">
              <button className="secondary">Secondary</button>
              <button className="danger">Danger</button>
            </div>
          </Box>
        </Modal.Body>
      </Modal> */}
      {/*----------// Fee Rule Delete Modal ---------*/}
    </div>
  );
};

export default FeeRuleCard;
